<app-hero-laboratorio/>
<app-info-laboratorio/>
